<template>
    <v-dialog :value="show" max-width="600" persistent>
        <v-card>
            <v-card-title class="headline">Supprimer la GNC</v-card-title>
            <v-card-text>
                <p>La GNC sera retirée de toutes les listes. Les TI peuvent la restaurer au besoin.</p>

                <v-progress-linear v-if="loadingApercu" indeterminate />

                <div v-else-if="apercu">
                    <h4>Effets dans Syteline</h4>
                    <p v-if="apercu.action === 'aucune'">{{ apercu.raison || 'Aucun effet à annuler.' }}</p>
                    <v-alert v-else-if="apercu.action === 'conserver'" :value="true" type="warning">{{ apercu.raison }}</v-alert>
                    <div v-else>
                        <p>Les éléments suivants seront supprimés du projet {{ apercu.projet }} :</p>
                        <ul>
                            <li v-for="element in apercu.elements" :key="element.libelle">{{ element.libelle }}</li>
                        </ul>
                    </div>
                </div>

                <v-form ref="form" v-model="formValid" lazy-validation>
                    <v-textarea
                        id="nc-suppression-raison"
                        v-model="raison"
                        label="Raison de la suppression"
                        :rules="[v => (!!v && v.trim().length >= 5) || 'Une raison d\'au moins 5 caractères est obligatoire']"
                        counter="1000"
                        rows="3"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn flat :disabled="loading" @click="$emit('cancel')">Annuler</v-btn>
                <v-btn color="error" :loading="loading" :disabled="loadingApercu || !apercu" @click="confirmer">Supprimer</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "DialogSuppressionNc",
        props: ['show', 'apercu', 'loadingApercu', 'loading'],
        data() {
            return { raison: '', formValid: true };
        },
        watch: {
            //repart d'un formulaire vide à chaque ouverture
            show(value) {
                if (value) {
                    this.raison = '';
                    this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
                }
            }
        },
        methods: {
            confirmer() {
                if (this.$refs.form.validate()) {
                    this.$emit('confirm', this.raison.trim());
                }
            }
        }
    }
</script>
